import { defineComponent as _defineComponent } from 'vue'
import { translateLang } from '@/data/i18n/translateLang'
import type { MixPaibanPlans } from '@/store/modules/IMaterialListType/type'
import { Empty } from 'ant-design-vue'
import { cloneDeep } from 'lodash'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-mix-paiban-plan-modal',
  props: {
    mixPaibanSettings: { default: () => [] },
    visible: { type: Boolean, default: false }
  },
  emits: ["update:visible", "ok"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (e: 'ok', ids: MixPaibanPlans[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mixPaibanSettings: MixPaibanPlans[], visible: boolean }




const data = ref(
  props.mixPaibanSettings.map((setting) => {
    return {
      ...setting,
      isSelected: setting.isSelected ?? false,
    }
  })
)

watch(
  () => props.mixPaibanSettings,
  (val) => {
    data.value = cloneDeep(val).map((setting) => {
      return {
        ...setting,
        isSelected: setting.isSelected ?? false,
      }
    })
  },
  {
    immediate: true,
  }
)

const isShow = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
  },
})

const handleCancel = () => {
  isShow.value = false
}

const handleOk = () => {
  isShow.value = false
  emit(
    'ok',
    data.value.filter((item) => item.isSelected)
  )
}

return { __sfc: true,emit, props, data, isShow, handleCancel, handleOk, translateLang, Empty }
}

})